import { Dispatch } from "redux"
import AxiosControl from '../../components/axios/AxiosControl'
const Axios = AxiosControl()

export const getPolicies = (page: number | null = null, limit: number | null = null, search: Object = '', sort: any = null) => async (dispatch: Dispatch) => {
    dispatch({ type: 'POLICY_LOADING' })
    try {
        const { data, status } = await Axios.post('/api/policy/getall/', { page, limit, search, sort }, {
            headers: { auth: localStorage.getItem('jwt'), ente: localStorage.getItem('enteId') }
        })
        if (status === 200) {
            dispatch({
                type: 'POLICY_GETALL_SUCCESS',
                payload: data
            })
        } else {
            dispatch({ type: 'POLICY_NOT_LOADING' })
        }
    } catch (error) {
        dispatch({ type: 'POLICY_NOT_LOADING' })
    }
}

export const getPoliciesByClient = (clientId: string, page: number | null = null, limit: number | null = null) => async (dispatch: Dispatch) => {
    dispatch({ type: 'POLICY_LOADING' })
    try {
        const { data, status } = await Axios.get(`/api/policy/getAllByClient/${clientId}`,
            {
                headers: { auth: localStorage.getItem('jwt'),ente: localStorage.getItem('enteId') }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'POLICY_GETALL_SUCCESS',
                payload: data
            })
        } else {
            dispatch({ type: 'POLICY_NOT_LOADING' })
        }
    } catch (error) {
        dispatch({ type: 'POLICY_NOT_LOADING' })
    }
}


export const getForSelect = () => async (dispatch: Dispatch) => {
    dispatch({ type: 'POLICY_LOADING' })
    try {
        const { data, status } = await Axios.get('/api/policy/getforselect/', {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'POLICY_GETALLFORSELECT_SUCCESS',
                payload: data
            })
        } else {
            dispatch({ type: 'POLICY_NOT_LOADING' })
        }
    } catch (error) {
        dispatch({ type: 'POLICY_NOT_LOADING' })
    }
}

export const getPolicy = (policy: string) => async (dispatch: Dispatch) => {
    dispatch({ type: 'POLICY_LOADING' })
    try {
        const { data, status } = await Axios.get('/api/policy/get/' + policy, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'POLICY_GET_SUCCESS',
                payload: data
            })
        } else {
            dispatch({ type: 'POLICY_NOT_LOADING' })
        }
    } catch (error) {
        dispatch({ type: 'POLICY_NOT_LOADING' })
    }
}

export const readPolicy = (idPolicy: string) => async (dispatch: Dispatch) => {
    dispatch({
        type: 'POLICYDATA_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/policy/readPolicy/'+ idPolicy, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200 || status === 304) {
            dispatch({
                type: 'POLICYDATA_GET_SUCCESS',
                payload: data
            })
        } else {
            dispatch({
                type: 'POLICYDATA_NOT_LOADING'
            })
        }
    } catch (error) {
        dispatch({
            type: 'POLICYDATA_NOT_LOADING'
        })
    }
}

export const editPolicy = (policy: any, id?: string) => async (dispatch: Dispatch) => {
    dispatch({ type: 'POLICY_LOADING' })
    // Defensa: el detalle de póliza expone el id como _id. Sin este fallback
    // se hacía PUT /api/policy/edit/undefined y la nota se perdía.
    const policyId = id ?? policy?.id ?? policy?._id
    try {
        const { data, status } = await Axios.put('/api/policy/edit/' + policyId, policy, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200 || status === 264 || status === 260) {
            dispatch({
                type: 'POLICY_EDIT_SUCCESS',
                payload: { message: data.message, id: policyId, updatedPolicy: policy }
            })
        } else {
            dispatch({ type: 'POLICY_NOT_LOADING' })
        }
    } catch (error) {
        dispatch({ type: 'POLICY_NOT_LOADING' })
    }
}